import { render, staticRenderFns } from "./ProductSalesModal.vue?vue&type=template&id=05ab3828&"
import script from "./ProductSalesModal.vue?vue&type=script&lang=js&"
export * from "./ProductSalesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports